window.validation = function (room) {
  var date = $("#datepicker").val();
  var block = $("#hour_selector").val();
  if (date == "") {
    window.alert("Debes seleccionar una fecha");
    return false;
  }

  $.ajax({
    type: "POST",
    url: "/reservations/validation",
    data: {
      date: date,
      room: room,
      block: block,
    },
    dataType: "json",
    success: function (data) {
      if (data.value == 0) {
        window.alert(
          'Horario o fecha seleccionada ya están reservados\nPuedes revisar la disponibilidad en la sección "Revisar Disponibilidad"'
        );
      } else {
        alert(
          "Estas generando una pre-reserva, la cual está sujeta a confirmación. Esta información será notificada a su mail"
        );
        window.update_dates_repeat();
        if ($("#repeat-reservation").is(":checked")) {
          var start = $("#start-repeat").val().replace(/-/g, "/"),
            end = $("#end-repeat").val().replace(/-/g, "/"),
            day = $("#day-repeat").val(),
            block = $("#block-repeat").val(),
            step = $("#step-repeat").val(),
            room = $("#room_id").val();

          dates = window.getDaysBetweenDates(start, end, day, step);
          $.ajax({
            type: "POST",
            url: "/reservations/check_repeat",
            data: {
              room: room,
              start: start,
              end: end,
              day: day,
              block: block,
              step: step,
              dates: dates,
            },
            dataType: "json",
            success: function (data) {
              if (data.dates.length) {
                alert(
                  'Horario o fecha seleccionada ya están reservados\nPuedes revisar la disponibilidad en la sección "Revisar Disponibilidad"'
                );
              } else {
                $("#reservation").submit();
              }
            },
          });
        } else {
          $("#reservation").submit();
        }
      }
    },
    error: function (XMLHttpRequest, textStatus, errorThrown) {
      alert("Status: " + textStatus);
      alert("Error: " + errorThrown);
    },
  });
};

window.check_no_negative = function (text_id) {
  var value = $(text_id).val();
  if (value < 0) {
    $(text_id).css("border-bottom", "3px solid #e62639");
    $(text_id).val(0);
  } else {
    $(text_id).css("border-bottom", "1px solid gray");
  }
};

window.check_img = function (form) {
  if ($("#img_button")[0].files.length > 0) {
    $(form).submit();
  } else {
    alert("Debe agregar al menos una imagen");
  }
};

window.check_img_edit = function (number, form) {
  if ($("#img_button")[0].files.length + number > 0) {
    $(form).submit();
  } else {
    alert("Debe agregar al menos una imagen");
  }
};

window.enable_coffe = function () {
  $("#coffee_selector").prop("disabled", !$("#coffeswitch").is(":checked"));
  $("#coffe_backup").prop("disabled", $("#coffeswitch").is(":checked"));
  $("#amount-coffe").prop("disabled", !$("#coffeswitch").is(":checked"));
};

window.show_info = function (text_id, selector) {
  $(text_id).prop("hidden", !$(selector).is(":checked"));
};

window.enable_info = function (text_id, selector) {
  $(text_id).prop("disabled", !$(selector).is(":checked"));
};

window.check_billing = function (form) {
  var voids_c1 = false;
  var voids_c2 = false;
  $("#billingcolumn1 > input").each(function () {
    voids_c1 = $(this).val() == "";
  });

  $("#billingcolumn2 > input").each(function () {
    voids_c2 = $(this).val() == "";
  });
  if (!(voids_c1 || voids_c2)) {
    $(form).submit();
  } else {
    alert("Todos los campos son obligatorios");
  }
};

window.check_password = function () {
  var pass = $("#pass-field").val();
  if (pass.length < 6) {
    $("#alert-password").html("Contraseña muy corta");
    $("#register-form-button").prop("disabled", true);
  } else {
    $("#alert-password").html("");
    $("#register-form-button").prop("disabled", false);
  }
};

window.check_password_equal = function () {
  var pass = $("#pass-field").val();
  if (pass != $("#pass-field-confirm").val()) {
    $("#alert-password-confirm").html("Contraseñas no coinciden");
    $("#register-form-button").prop("disabled", true);
  } else {
    $("#alert-password-confirm").html("");
    $("#register-form-button").prop("disabled", false);
  }
};
window.denied_explanation_form = function (select_id, input_id) {
  $(input_id).prop("disabled", $(select_id).val() != 3);
};

window.check_amout_people = function () {
  var amount = $("#as"),
    radio = $("input[name='reservation[amount]']:checked");
  if (parseInt(amount.val()) > parseInt(radio.val())) {
    alert("Cantidad de asistentes supera capacidad seleccionada");
    amount.val(radio.val());
  }
};

window.confirm_delete = function (form_id) {
  var form = $(form_id),
    result = confirm(
      "¿Seguro que quieres eliminar la reserva?, esta acción no se puede deshacer"
    );
  if (result) {
    console.log("send");
    form.submit();
  }
};

window.check_free_or_discount = function (
  is_free,
  discount_name,
  discount,
  form_id
) {
  var form = $(form_id);
  if (is_free) {
    var conf = confirm(
      "ATENCIÓN: ¿La reserva fue declarada SIN COSTO, seguro que desea continuar?"
    );
    if (conf) {
      form.submit();
    }
  }
  if (discount_name != "null") {
    if (discount != "null") {
      form.submit();
    } else {
      alert(
        "La Reserva declara tener un descuento, debes ingresar al detalle de la reserva para asignarlo"
      );
    }
  }
};
